<template>
  <component
    :is="currentTemplate"
    v-bind="{ ...currentNotify.data, currentNotify: { ...currentNotify } }"
    :old-message="currentNotify.message"
    :old-title="currentNotify.title"
    @close="nextNotification"
    v-if="currentNotify"
    :key="currentNotify.id"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { kebabCase } from 'lodash';
import DefaultNotification from './Template/DefaultNotification.vue';

export default {
  name: 'SystemNotify',
  created() {
    this.$cheeers.socket.on('newNotification', (notification) => {
      this.pushNotification(notification);
    });
  },
  data: () => ({
    show: false,
    socket: undefined,
  }),
  computed: {
    ...mapState('staff', ['notify']),
    currentNotify() {
      return this.notify[0];
    },
    currentTemplate() {
      if (!this.currentNotify) {
        return null;
      }
      const keys = Object.keys(this.$options.components);
      if (
        keys.some(
          (key) =>
            this.$options.components[key] &&
            (this.$options.components[key].name === this.currentNotify.template ||
              kebabCase(this.$options.components[key].name) === this.currentNotify.template),
        )
      ) {
        return this.currentNotify.template;
      }
      return 'default-notification';
    },
  },
  methods: {
    ...mapActions('staff', ['removeFirstNotification', 'pushNotification']),
    nextNotification() {
      this.removeFirstNotification();
    },
  },
  components: {
    DefaultNotification,
    HappyBirthDay: () => import('./Template/HappyBirthDay.vue'),
    NewMessage: () => import('./Template/NewMessage.vue'),
    LateList: () => import('./Template/LateList.vue'),
    CompanySendPoint: () => import('./Template/CompanySendPoint.vue'),
    FinishWorking: () => import('./Template/FinishWorking.vue'),
    CongratulationsEmployee: () => import('./Template/CongratulationsEmployee.vue'),
    SurveyQuestion: () => import('./Template/SurveyQuestion.vue'),
    MissionComplete: () => import('./Template/MissionComplete.vue'),
    SloganAnswer: () => import('./Template/SloganAnswer.vue'),
  },
};
</script>

<style scoped></style>
